document.addEventListener("DOMContentLoaded", function() {
    function loaderFinished() {
        document.querySelector('.imgloading-container').classList.add('fast-animation');
        document.body.classList.add('loaded');
    }

    const loader = document.getElementById('loader-wrapper');

    if (loader) {
        let minLoadTime = 500;
        let startTime = Date.now();

        window.addEventListener('load', function () {
            let elapsedTime = Date.now() - startTime;
            let remainingTime = Math.max(0, minLoadTime - elapsedTime);

            setTimeout(function () {
                loaderFinished();
            }, remainingTime);
        });

        let maxLoadTime = 2000;

        setTimeout(function () {
            loaderFinished();
        }, maxLoadTime);
    }
});